"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Messages = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Message = require("./Message");
var _InteractiveChatMessages = require("../InteractiveChatMessages.styled");
var _hooks = require("../../../../hooks");
var _ScrollButton = require("./ScrollButton");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Messages = exports.Messages = function Messages(_ref) {
  var messages = _ref.messages,
    loadMore = _ref.loadMore;
  var _useIntersectionObser = (0, _hooks.useIntersectionObserver)({}),
    _useIntersectionObser2 = (0, _slicedToArray2["default"])(_useIntersectionObser, 2),
    ref = _useIntersectionObser2[0],
    shouldLoadmore = _useIntersectionObser2[1];
  var _useScrollPosition = (0, _hooks.useScrollPosition)(),
    _useScrollPosition2 = (0, _slicedToArray2["default"])(_useScrollPosition, 3),
    messagesRef = _useScrollPosition2[0],
    isScrolling = _useScrollPosition2[1],
    onJumpToLatest = _useScrollPosition2[2];
  (0, _react.useEffect)(function () {
    if (shouldLoadmore && messages.length > 1) {
      loadMore();
    }
  }, [shouldLoadmore]);
  return /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.MessagesWrapper, null, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.MessagesContainer, {
    "data-testid": "messages-container",
    className: "messages-container",
    ref: messagesRef,
    "aria-live": "polite"
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "load-more",
    ref: ref
  }), messages.map(function (message) {
    return /*#__PURE__*/_react["default"].createElement(_Message.Message, {
      className: "dd-privacy-mask",
      message: message,
      key: message._id
    });
  })), isScrolling && /*#__PURE__*/_react["default"].createElement(_ScrollButton.ScrollButton, {
    onJumpToLatest: onJumpToLatest
  }));
};
Messages.propTypes = {
  messages: _propTypes.array,
  loadMore: _propTypes.func
};